<template>
  <div v-if="ticket">
    <v-layout row wrap>
      <v-flex xs12 sm12 md8>
        <div class="display-1">
          {{ ticket.name }}
          <!-- Reserved checkmark -->
          <v-tooltip
            v-if="hasGroupTicketPurchased(ticket.id)"
            top
            color="primary"
          >
            <template v-slot:activator="{ on }">
              <v-chip
                v-on="on"
                small
                v-if="hasGroupTicketPurchased(ticket.id)"
                color="success"
                outline
              >
                <v-avatar>
                  <v-icon>check_circle</v-icon>
                </v-avatar>
                {{ $t("screener.purchased.title") }}
              </v-chip>
            </template>
            <span class="background--text text--darken-3 body-1">{{
              $t("screener.purchased.group_ticket.tooltip")
            }}</span>
          </v-tooltip>
        </div>
      </v-flex>
      <v-flex xs12 sm12 md4 class="text-xs-left text-md-right">
        <div class="display-1">
          <span class="px-1">{{ getCurrencySymbol(ticket.currency) }}</span>
          <span>{{ ticket.price }}</span>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm12 md8>
        <div class="subheading">
          <span>{{ $t("screenings.title") }} : </span>
          <span style="font-weight: bold">{{ ticket.screenings.length }}</span>
        </div>
        <div class="subheading">
          {{
            $t("screener.monetization.group_ticket.valid_till", {
              end_date: moment
                .utc(ticket.purchasing_end_date)
                .local()
                .format("lll")
            })
          }}
        </div>
      </v-flex>
      <v-flex xs12 sm12 md4 class="text-xs-left text-md-right">
        <v-btn
          v-if="!hasGroupTicketPurchased(ticket.id)"
          @click.stop="$emit('initiate-enrollment')"
          class="mx-0 background primary--text"
          :disabled="isGeoBlocked"
          >{{ $t("screener.btn.buy_pass") }}</v-btn
        >
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { currencySymbol } from "@/mixins/currencySymbol";
import { hasGroupTicketPurchased } from "@/mixins/monetization";

const props = {
  ticket: {
    type: Object,
    default: null
  },
  isGeoBlocked: {
    type: Boolean,
    default: false
  }
};

export default {
  name: "GroupTicketHeader",
  props: props,
  mixins: [currencySymbol, hasGroupTicketPurchased]
};
</script>

<style></style>
